var React = require('react');

function BarrierFreeInline (props) {
    return React.createElement("path",props);
}

BarrierFreeInline.defaultProps = {"d":"M38,6H10c-2.22,0-4,1.8-4,4v28c0,2.200001,1.78,4,4,4h28c2.200001,0,4-1.799999,4-4V10\n\tC42,7.8,40.220001,6,38,6z M38,38H10V14h28V38z M24,21c3.68,0,6.959999,1.92,8.68,5c-1.720001,3.08-5,5-8.68,5\n\ts-6.959999-1.92-8.68-5C17.040001,22.92,20.32,21,24,21 M24,18c-5.459999,0-10.12,3.32-12,8c1.88,4.68,6.540001,8,12,8\n\ts10.119999-3.32,12-8C34.119999,21.32,29.459999,18,24,18L24,18z M24,29c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3S25.66,29,24,29z"};

module.exports = BarrierFreeInline;

BarrierFreeInline.default = BarrierFreeInline;
